// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"483":"c081a574","638":"6a216347","797":"597d98a7"}[chunkId] + ".chunk.css";
};